import { useAppDispatch } from "@/state/redux/hooks";
import { requestOpenCollectionsSidebar } from "@/state/redux/slices/ui";
import { memo, PropsWithChildren } from "react";
import { Button } from "../button";
import { useBreakpoint } from "@/common/hooks";
import { HeaderText } from "./Header";

function CurrentPageWidget({ children }: PropsWithChildren) {
  const dispatch = useAppDispatch();
  const { isMd } = useBreakpoint();
  const handleOpenCollections = () => {
    dispatch(requestOpenCollectionsSidebar(true));
  };

  if (isMd) {
    return <HeaderText>{children}</HeaderText>;
  }
  return (
    <Button variant="ghost" size="sm" onClick={handleOpenCollections}>
      {children}
    </Button>
  );
}

export default memo(CurrentPageWidget);
